export enum DaysOfWeek {
  MONDAY = 'MONDAY',

  TUESDAY = 'TUESDAY',

  WEDNESDAY = 'WEDNESDAY',

  THURSDAY = 'THURSDAY',

  FRIDAY = 'FRIDAY',

  SATURDAY = 'SATURDAY',

  SUNDAY = 'SUNDAY',
}
